import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { Space, SpaceDefinition } from '../../../core/access/space';

/**
 * Le choix d'un espace — compact dans la carte de profil du menu, en cartes
 * sur l'écran de première connexion. Même liste, même icônes, même libellés :
 * un seul composant, deux rendus.
 */
@Component({
  selector: 'app-space-switcher',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './space-switcher.component.html',
  styleUrl: './space-switcher.component.css',
})
export class SpaceSwitcherComponent {
  @Input({ required: true }) spaces: SpaceDefinition[] = [];
  @Input() current: Space | null = null;
  @Input() variant: 'compact' | 'cards' = 'compact';

  @Output() readonly select = new EventEmitter<Space>();
}
